export const JOB_STATUSES: { [key in JobStatus]: JobStatus } = {
  PUBLISHED: 'PUBLISHED',
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
  ARCHIVED: 'ARCHIVED',
} as const;

export const JOB_STATUS_TEXT = {
  PUBLISHED: 'Actively Advertising',
  ACTIVE: 'Hiring, Not Advertising',
  CLOSED: 'Not Currently Hiring',
  ARCHIVED: 'Archived',
} as const;

export const ACTIVE_STATUSES = [JOB_STATUSES.PUBLISHED, JOB_STATUSES.ACTIVE] as const;

export const ORDERED_JOB_STATUSES = [
  JOB_STATUSES.PUBLISHED,
  JOB_STATUSES.ACTIVE,
  JOB_STATUSES.CLOSED,
  JOB_STATUSES.ARCHIVED,
] as const;

export const isActiveStatus = (jobStatus: string): jobStatus is ActiveJobStatus =>
  ACTIVE_STATUSES.includes(jobStatus as ActiveJobStatus);

export type FilterByJobStatus = 'allJobs' | 'allHiring';
export const isValidFilterByJobStatus = (val: any): val is FilterByJobStatus =>
  val === 'allJobs' || val === 'allHiring';
export const ALLOWED_JOB_STATUS_FILTERS = ['allJobs', 'allHiring'];
export const getJobStatusesForFilter = (jobStatusFilter?: FilterByJobStatus) =>
  jobStatusFilter?.toLowerCase() === 'allhiring'
    ? [JOB_STATUSES.PUBLISHED, JOB_STATUSES.ACTIVE]
    : ORDERED_JOB_STATUSES;
export const JOB_STATUS_OPTIONS = {
  ALL_JOBS: 'allJobs',
  ALL_HIRING: 'allHiring',
} as const;
export const JobStatusOptions = [
  { value: 'allJobs', label: 'All Jobs', optionGroup: 'Job Status' },
  { value: 'allHiring', label: 'All Hiring', optionGroup: 'Job Status' },
];
